import { size, replace } from 'lodash';

export function stringToCNPJ(value: string): string {
  // Remove caracteres que não sejam letras ou números
  const cgc = replace(value, /[^a-zA-Z0-9]/g, '');

  // Aplica o formato correto de CNPJ: NN.NNN.NNN/NNNN-99
  return replace(cgc, /^(\w{2})(\w{3})(\w{3})(\w{4})(\w{2})$/, "$1.$2.$3/$4-$5");
}